import React from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class HorizontalThumbnail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settings: {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 900,
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 2000,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                        },
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll:5,
                        },
                    },
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },

                ],
            },
            Muted: false,
            isVideoThumbonHover: false,
            thumbnailIndex: 0,
            itemDescription:'',
            isMutedThumbnailVideo:false,
            zoomThumbnailImgurl:'',
            hasTrailer_dataItemIndex:null
        }    
    }


    hoverThumbnail = (e,key, entryidmain, trailer_data) => {
        this.setState({ isVideoThumbonHover: true, thumbnailIndex: key})
        
        if(trailer_data.length!==0){
            this.setState({ hasTrailer_dataItemIndex:key})
        }

        if(localStorage.getItem('isMutedThumbnailVideo')==='true'){
            this.setState({ isMutedThumbnailVideo: true })   
        }else{
            this.setState({ isMutedThumbnailVideo: false })   
        }

        localStorage.setItem('isVideoThumbonHover',true)
    }

    hoverOutThumbnail = () => {
        this.setState({ isVideoThumbonHover: false })     
        this.setState({ hasTrailer_dataItemIndex:null})
        localStorage.setItem('isVideoThumbonHover',false)
    }
    modaltoogle = (itms) => {
        this.setState({ isModel: !this.state.isModel, modaltog: itms })
        document.body.classList.add('overflow-hidden');
        document.querySelector('#header').classList.add('down')
    }
    modaltoogleclose = (itms) => {
        this.setState({ isModel: !this.state.isModel })
        document.body.classList.remove('overflow-hidden');
        document.querySelector('#header').classList.remove('down')
    }

    componentDidMount() {
        const theme = localStorage.getItem('themeColor');
        if (theme === 'blckThem') {
            this.setState({ placeholderImage: 'dark' })
        } else {
            this.setState({ placeholderImage: 'light' })
        }
        localStorage.setItem('isMutedThumbnailVideo', false)
    }
    
    render() {
        return (
            <>
                <section>
                    <div className="thm_Sldr_wppr pt-4">
                        <div className="container">
                            <div className="row">
                                <div className="thm_slr_cntct">
                                    <div className="thm_hdng_wppr">
                                        <div className="title d-flex align-item-center justify-content-between">
                                            <h3>
                                                {this.props.uniqId !== "season_list" && this.props.Itmdata.title_tag_name}
                                                {this.props.uniqId === "season_list" && this.props.Itmdata.Parent_name}
                                            </h3>
                                            <div className="viw-btn-wppr">
                                                {(this.props.uniqId !== "season_list" && this.props.Itmdata.categoryid !== 0 && (this.props.Itmdata.cat_type === "sh" || this.props.Itmdata.cat_type === "ser" || this.props.Itmdata.cat_type === "sea")) && <Link to={`/${(this.props.route_name.replace(/\s/g, '')).toLowerCase()}/collection/season/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '_')).toLowerCase()}/${this.props.Itmdata.categoryid}`}>{this.props.Itmdata.cat_type === 'ser' ? "" : `View All`}</Link>}
                                                {(this.props.uniqId !== "season_list" && this.props.Itmdata.categoryid > 0 && (this.props.Itmdata.cat_type === "cat")) && <Link to={`/${(this.props.route_name.replace(/\s/g, '')).toLowerCase()}/collectionv/${(this.props.Itmdata.title_tag_name.replace(/\s/g, '_')).toLowerCase()}/${this.props.Itmdata.categoryid}`}></Link>}
                                                {(this.props.uniqId === "season_list" && this.props.Itmdata.Parent_id !== 0) && <Link to={`/${(this.props.route_name.replace(/\s/g, '')).toLowerCase()}/collectionv/${(this.props.Itmdata.Parent_name.replace(/\s/g, '_')).toLowerCase()}/${this.props.Itmdata.Parent_id}`}>{this.props.Itmdata.cat_type === 'ser' ? "" : `View All`}</Link>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="thm_slr_bx">
                                    <Slider {...this.state.settings} className='thumb_slider position-relative topPicks' >
                                            {this.props.Itmdata.search_tag.map((itms, key) => {
                                                let isPremium = itms.ispremium === 1 ? 'thm_slr_itm_img prmum-txt' : 'thm_slr_itm_img';
                                                return (
                                                    <>
                                                        <div className="thm_sldr_itm" key={key}>
                                                            {
                                                                this.props.Itmdata.cat_type === "cat" && <div className={isPremium} key={key}>
                                                                    <Link to={`/video/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.entryid}`} className={`box`} key={key}>
                                                                        <img src={itms.thumburl.h_thumburl ? itms.thumburl.h_thumburl : itms.thumburl.v_thumburl + "/width=240/height=130/quality=100"} alt="" key={key} />
                                                                    </Link>
                                                                </div>
                                                            }
                                                            {
                                                                ((this.props.Itmdata.cat_type === "sh" || this.props.Itmdata.cat_type === "ser" || this.props.Itmdata.cat_type === "sea") && this.props.uniqId !== "season_list") && <div className={isPremium} key={key}>
                                                                    <Link to={(this.props.Itmdata.cat_type === "sh" && itms.sub_count === 0) ? `/video/${(itms.name.replace(/\s/g, '_')).toLowerCase()}/${itms.id}` : itms.sub_count == null ? `/cat/${this.props.route_name}/${(itms.name.replace(/\s/g, '_')).toLowerCase()}/${itms.id}` : `/season/${(itms.name.replace(/\s/g, '')).toLowerCase()}/${itms.id}`} key={key}>
                                                                        <img src={itms.t_custom_url + "/width=240/height=130/quality=100"} alt="" key={key} />
                                                                    </Link>
                                                                </div>
                                                            }
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default HorizontalThumbnail;
